import { Signal } from '@angular/core';
import { CanDeactivateFn, RouterStateSnapshot } from '@angular/router';
import { EnableEntityComponent } from '@r1-compass-library/components/enable-entity/enable-entity.component';
import { Observable, of } from 'rxjs';
import { SaveGuardCallback, unsavedChangesHandler } from '../hasUnsavedChanges.guard';
import { MutationResult } from '@angular-architects/ngrx-toolkit';
import { ContentAsset, TemplateCriteria } from '@r1-compass-library/models';
import { LifecycleRuleset } from '@r1-compass-library/models/lifecycle-rules/lifecycle-ruleset.model';

export interface EnableSaveGuardWarning {
    enableComponentSpy: Signal<EnableEntityComponent>;
    onSave: () => Promise<MutationResult<void | TemplateCriteria | ContentAsset | LifecycleRuleset>>;
}

/**
 * @description Needs to wait on init to happen before form state can be tracked
 */
export const hasUnsavedChangesEnableComponent: CanDeactivateFn<EnableSaveGuardWarning> = (
    component: EnableSaveGuardWarning,
    _currentRoute,
    _routerStateSnapshot,
    nextState: RouterStateSnapshot
): Observable<boolean> => {
    const responseCallback = (response: SaveGuardCallback) => {
        if (response?.type === 'confirm') {
            return component.onSave().then(() => true);
        }
        return response?.type === 'confirmWithoutSave' ? of(true) : of(false);
    };
    return unsavedChangesHandler(
        nextState,
        responseCallback,
        true,
        false,
        component.enableComponentSpy().statusChanged()
    );
};
